module.exports = __webpack_public_path__ + "static/media/ios-git-network.01863984.svg";